import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { queuePDFService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as queuePDFActions from './actions';

export function getStoredPDFStatistics(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_PDF_STATISTICS),
    mergeMap(({ payload }) => {
      return queuePDFService.getStoredPDFStatistics(payload)
        .pipe(
          map(res => queuePDFActions.getStoredPDFStatisticsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}

export function removeQueue(action$) {
  return action$.pipe(
    ofType(actionTypes.REMOVE_QUEUE),
    mergeMap(({ payload }) => {
      return queuePDFService.removeQueue(payload)
        .pipe(
          map(res => queuePDFActions.removeQueueSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}